import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import {
  getToken,
  setToken
} from '@/utilsCloud/auth'

router.beforeEach((to, from, next) => {
  if (to.path !== '/null') {
    // 获取企业id和浏览器信息
    let entpWebsite = location.origin;
    // 开发模式定义固定域名
    // const testUrl = to.query.devhost || 'http://jg0011026.e.hbzclm.com/';
    // const testUrl = to.query.devhost || 'http://dlpxxx001.e.hbzclm.com/';
    // const testUrl = to.query.devhost || 'http://wxjg001.e.hbzclm.com/';
    const testUrl = to.query.devhost || 'http://cspx001.e.eceping.net/';
    // const testUrl = to.query.devhost || 'https://cspx.e.hbzclm.com/'; // 测试环境
    if (process.env.NODE_ENV === "development") {
      entpWebsite = testUrl
    }
    store.dispatch('GetEnterprise', {
      entpWebsite
    }).then(res => {
      store.dispatch('GetWebSite')
      // 获取用户信息
      if (getToken()) {
        localStorage.setItem('tokenId', getToken())
        store.dispatch('GetInfo').then(() => {
          next()
        }).catch(err => {
          next();
        })
      } else {
        next()
      }
    }).catch(err => {
      next()
    });
  } else {
    next()
  }

})



// WEBPACK FOOTER //
// ./src/permission.js